module.exports = __webpack_public_path__ + "static/img/comp.ffa0dd91.png";